var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 14.0006H14.7101L14.4301 13.7306C15.6301 12.3306 16.2501 10.4206 15.9101 8.39063C15.4401 5.61063 13.1201 3.39063 10.3201 3.05063C6.09014 2.53063 2.53014 6.09063 3.05014 10.3206C3.39014 13.1206 5.61014 15.4406 8.39014 15.9106C10.4201 16.2506 12.3301 15.6306 13.7301 14.4306L14.0001 14.7106V15.5006L18.2501 19.7506C18.6601 20.1606 19.3301 20.1606 19.7401 19.7506C20.1501 19.3406 20.1501 18.6706 19.7401 18.2606L15.5001 14.0006ZM9.50014 14.0006C7.01014 14.0006 5.00014 11.9906 5.00014 9.50063C5.00014 7.01063 7.01014 5.00063 9.50014 5.00063C11.9901 5.00063 14.0001 7.01063 14.0001 9.50063C14.0001 11.9906 11.9901 14.0006 9.50014 14.0006Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1f787aef50d9e544626a2baeaed829a8.svg";
export { ForwardRef as ReactComponent };